import { Spacings } from '@picsart/design-system/foundation/spacings';
import { BreakPoints } from '@picsart/design-system/foundation/responsive';
import { mediaQuery } from '@picsart/rc/helpers';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    root: {
      position: 'relative',
      gap: Spacings.s4,
      [mediaQuery(BreakPoints.Small)]: {
        width: '100%',
      },
    },
    searchInputWithSelector: {
      width: 538,
      [mediaQuery(BreakPoints.Small)]: {
        width: '100%',
      },
    },
  },
  { name: 'search-input' },
);

export default useStyles;
